/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceRequestType
 */
export interface ServiceRequestType {
    /**
     * 
     * @type {string}
     * @memberof ServiceRequestType
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceRequestType
     */
    name: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRequestType
     */
    allowLineSelection: boolean | null;
}

/**
 * Check if a given object implements the ServiceRequestType interface.
 */
export function instanceOfServiceRequestType(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "allowLineSelection" in value;

    return isInstance;
}

export function ServiceRequestTypeFromJSON(json: any): ServiceRequestType {
    return ServiceRequestTypeFromJSONTyped(json, false);
}

export function ServiceRequestTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceRequestType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'allowLineSelection': json['allowLineSelection'],
    };
}

export function ServiceRequestTypeToJSON(value?: ServiceRequestType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'allowLineSelection': value.allowLineSelection,
    };
}

